module.exports = __webpack_public_path__ + "static/img/Privacy-policy.d13640d.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/Privacy-policy.jpg
// module id = 2Srp
// module chunks = 1